module.exports = __webpack_public_path__ + "media/slider/Banner-11-21c4a497.jpg";